<div class="modal floating-close {{modal_class}}" id="{{id}}" tabindex="0" role="dialog"
data-keyboard="{{enable_alt_close}}" data-backdrop={{#if enable_alt_close}}"true"{{else}}"static"{{/if}}>
 <div class="modal-dialog {{dialog_class}}">
   <div class="modal-content {{content_class}}">
     {{#if no_header}}
     <span class="screen-reader-content">{{sr_no_header_caption}}</span>
     {{/if}}
     <button type="button" class="modal-floating-close {{#if button_class}}{{button_class}}{{else}}btn btn-default{{/if}}"
       data-dismiss="modal" {{#unless prevent_close_feedback}} data-close="true" {{/unless}}>
       <span class="screen-reader-content">{{#if sr_close_caption}}{{t sr_close_caption}}{{else}}{{t
         close_caption}}{{/if}}</span>
       {{>icon uuid=cid prefix="fal" name="fa-times" size="fa-lg"}}
       <span class="fab-caption">{{t close_caption}}</span>
     </button>
     {{#unless no_header}}
     <div class="modal-header {{header_class}}">
       <div class="modal-title {{title_class}}" id="{{id}}_label">{{t header}}</div>
     </div>
     {{/unless}}
     <div class="modal-body {{body_class}}">
       {{#if description}}<p>{{t description}}</p>{{/if}}
       {{#if blocks}}
       <div data-region="{{cid}}-modal-blocks"></div>
       {{/if}}
     </div>
     {{#unless no_footer}}
     <div class="modal-footer {{footer_class}}">
     </div>
     {{/unless}}
   </div>
 </div>
</div>
